import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, MenuItem } from '@material-ui/core';
import { CStandardInput } from '../../component/Input';
import { setClaimDraft, getLawyers } from '../../actions/claimAction';
import { DefaultSelect } from '../../component/Select';

const useStyles = makeStyles({
  gridContainer: {
    alignItems: 'space-between',
    display: 'grid',
    gridRowGap: '35px',
    gridTemplateColumns: '315px 315px',
    height: '100%',
    justifyContent: 'space-between',
    width: '100%'
  },
  gridItem: {
    width: '315px'
  },
  mainDiv: {
    background: '#F0F4FF',
    borderRadius: '10px',
    margin: '30px 40px 0px 35px',
    padding: '40px 135px'
  },
  phoneWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '320px'
  },
  root: {
    ' & .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '14px 16px',
      width: '315px'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontFamily: 'Poppins',
      fontSize: '12px',
      left: '13px',
      textAlign: 'start',
      top: '-7px',
      width: 'fit-content',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-15px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  rootPhone: {
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '14px 16px',
      width: '220px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '13px',
      top: '-7px',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-27px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  selectHeader: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    margin: '0px',
    textAlign: 'start',
    transform: 'translate(-30px, -15px) scale(0.83)'
  },
  selectHeaderLawyer: {
    transform: 'translate(-30px, -16px) scale(0.83)'
  },
  selectHeaderPhone: {
    transform: 'translate(-10px, -10px) scale(0.83)'
  },
  signature: {
    background: '#CAD8FF',
    borderRadius: '10px',
    maxHeight: '100%',
    maxWidth: '100%'
  },
  signature1: {
    background: '#CAD8FF',
    borderRadius: '10px',
    height: '70px',
    maxWidth: '100%'
  }
});

const Lawyer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const phoneCodes = ['+995'];
  const claimDraft = useSelector(({ claims }) => claims.claimDraft);
  const lawyers = useSelector(({ claims }) => claims.lawyers);

  useEffect(() => {
    const load = async () => {
      dispatch(getLawyers());
    };
    load();
  }, [dispatch]);

  return (
    <div className={classes.mainDiv}>
      <div className={classes.gridContainer}>
        <div className={classes.gridItem}>
          <div style={{ width: 'fit-content' }}>
            <p className={`${classes.selectHeader} ${classes.selectHeaderLawyer} `}>Assigned To</p>
            <DefaultSelect
              onSelect={(value) => {
                const [selectedLawyerContent] = lawyers.filter((lawyer) => {
                  return lawyer.lawyerFullName === value;
                });
                dispatch(
                  setClaimDraft({
                    ...claimDraft,
                    lawyerAddress: selectedLawyerContent.lawyerAddress,
                    lawyerEmail: selectedLawyerContent.lawyerEmail,
                    lawyerFullName: value,
                    lawyerPhoneCode: selectedLawyerContent.lawyerPhoneCode,
                    lawyerPhoneNumber: selectedLawyerContent.lawyerPhoneNumber,
                    lawyerSignatureUrl: selectedLawyerContent.lawyerSignatureFile
                  })
                );
              }}
              selectStyles={{ transform: 'translateY(-10px)', width: '315px' }}
              value={claimDraft.lawyerFullName || ''}
            >
              {lawyers?.map((lawyer) => {
                return (
                  <MenuItem key={lawyer.lawyerEmail} value={lawyer.lawyerFullName}>
                    {lawyer.lawyerFullName}
                  </MenuItem>
                );
              })}
            </DefaultSelect>
          </div>
        </div>

        <div className={classes.gridItem}>
          <div className={classes.phoneWrapper}>
            <div style={{ width: 'fit-content' }}>
              <p className={`${classes.selectHeader} ${classes.selectHeaderPhone} `}>Phone</p>
              <DefaultSelect
                onSelect={(value) => {
                  return dispatch(setClaimDraft({ ...claimDraft, lawyerPhoneCode: value }));
                }}
                selectStyles={{ transform: 'translateY(-6px)', width: '85px' }}
                value={claimDraft.lawyerPhoneCode || ''}
              >
                {phoneCodes.map((phoneCode) => {
                  return (
                    <MenuItem key={phoneCode} value={phoneCode}>
                      {phoneCode}
                    </MenuItem>
                  );
                })}
              </DefaultSelect>
            </div>
            <CStandardInput
              disableUnderline
              formclasses={{ root: classes.rootPhone }}
              htmlFor="standard-input-claim-detail-address"
              // defaultValue={selectedClaim.lawyerPhoneNumber || ''}
              id="standard-input-claim-detail-address"
              onChange={(event) => {
                return dispatch(
                  setClaimDraft({
                    ...claimDraft,
                    lawyerPhoneNumber: event.target.value
                  })
                );
              }}
              size="large"
              value={claimDraft.lawyerPhoneNumber}
            />
          </div>
        </div>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-id-number"
            id="standard-input-claim-detail-id-number"
            // defaultValue={selectedClaim.lawyerAddress || ''}
            label="Address"
            onChange={(event) => {
              return dispatch(
                setClaimDraft({
                  ...claimDraft,
                  lawyerAddress: event.target.value
                })
              );
            }}
            size="large"
            value={claimDraft.lawyerAddress || ''}
          />
        </div>
        <div className={classes.gridItem}>
          {claimDraft?.lawyerSignatureUrl ? (
            <img
              alt="layer signature"
              className={classes.signature}
              src={claimDraft.lawyerSignatureUrl}
            />
          ) : (
            <div className={classes.signature1} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Lawyer;
